import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import moment from "moment";
import translationEN from "./locales/en/translation.json";

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
};

i18n
  // load translation using http -> see /public/locales
  // learn more: https://github.com/i18next/i18next-http-backend
  // .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    lng: "en",
    fallbackLng: "en",
    ns: ["translation"],
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

i18n.services.formatter.add("short", (value, lng, options) => {
  let inputDate = moment(value);
  if (inputDate.isValid()) {
    moment.locale(lng);
    return inputDate.format("MM/DD/YYYY");
  }
});

export default i18n;
